export default __webpack_public_path__ + "img/esfmrFNd.3c7881c4.svg";